module.exports = __webpack_public_path__ + "static/media/sweet potato.c094dd11.jpg";